export default __webpack_public_path__ + "static/nyl_full-5983f22957aadcac239d39ca0849ed50.jpg";